import { useMemo } from 'react';
import { createLinkToPackage, createQSForLinkToPackage } from '../utils';
import { useGetWhitelabelDomain, useGetBaseQueryParams } from '../../../context/constructorContext';
import { useGetPackageData } from './useGetPackageData';

export const useGetLinkToPackage = () => {
  const whitelabelDomain = useGetWhitelabelDomain();
  const baseQueryParams = useGetBaseQueryParams();
  const { packageData } = useGetPackageData();

  const link = useMemo(() => {
    if (!packageData) {
      return undefined;
    }

    return createLinkToPackage(
      whitelabelDomain,
      packageData.id,
      createQSForLinkToPackage({
        search_type: packageData.search_type,
        baseQueryParams,
      })
    );
  }, [packageData]);

  return { linkToPackage: link };
};
